if (!customElements.get('random-video-rotator')) {
  customElements.define('random-video-rotator', class extends HTMLElement {
    connectedCallback() {
      var slots = Array.prototype.slice.call(this.querySelectorAll('[data-random-video-slot]'));
      if (!slots.length) return;
      var pick = slots[Math.floor(Math.random() * slots.length)];
      slots.forEach(function(s) { if (s !== pick) s.remove(); });
      pick.removeAttribute('hidden');
      var link = pick.getAttribute('data-video-link');
      var section = this.closest('[data-wetheme-section-id]');
      if (section) {
        var anchor = section.querySelector('[data-random-video-link]');
        if (anchor) {
          if (link) { anchor.setAttribute('href', link); anchor.style.display = 'block'; }
          else { anchor.style.display = 'none'; }
        }
      }
      var vid = pick.querySelector('video');
      if (vid) { vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
    }
  });
}
